import { IonText, IonIcon } from '@ionic/react';
import React from 'react';
import { eye, save } from 'ionicons/icons';
import './CrateMetrics.scss';

interface CrateMetricsProps {
  viewCount: number;
  saveCount: number;
  size?: 'small' | 'medium' | 'large';
}

export const CrateMetrics: React.FC<CrateMetricsProps> = ({
  viewCount = 0,
  saveCount = 0,
  size = 'medium',
}) => {
  const formatCount = (count: number): string => {
    if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}k`;
    }
    return count.toString();
  };

  return (
    <div className={`crate-metrics-container size-${size}`}>
      <div className="metric view-count">
        <IonIcon icon={eye} />
        <IonText>{formatCount(viewCount)}</IonText>
      </div>
      <div className="metric save-count">
        <IonIcon icon={save} />
        <IonText>{formatCount(saveCount)}</IonText>
      </div>
    </div>
  );
};
